import {
  BullQueueJobBody,
  BullQueueJobsBody,
  BullQueueParentFlowBody,
  FMSLocationData,
  FMSSyncedLocationData,
  FMSSyncedUserData,
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/bull/src/API/Bull/Bull.Controller.ts
export class BullAPI {
  static async queueJobs(body: BullQueueJobsBody, inBulk?: boolean) {
    const params = inBulk !== undefined ? { inBulk } : {};
    return APIService.Bull.post("/bull/queue-jobs", body, params);
  }

  static async queueJob(body: BullQueueJobBody) {
    return APIService.Bull.post("/bull/queue-job", body);
  }

  static async queueParentChildJobs(body: BullQueueParentFlowBody) {
    return APIService.Bull.post("/bull/queue-parent-child-jobs", body);
  }

  // static async syncUser(userId: number, body: { location: FMSLocationData }) {
  //   return APIService.Bull.post<FMSSyncedUserData>(`/bull/sync/user/${userId}`, body);
  // }
  static async syncUsersForLocation(orgId: number, locationId: number, userIds: number[]) {
    return APIService.Bull.put(`/bull/sync/orgId/${orgId}/location/${locationId}/users`, { userIds });
  }
}
